
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Invoice } from '@/models/accounting/Invoice'
import { Document } from '@/models/Document'
import { PluralResponse } from 'coloquent/dist/response/PluralResponse'
import { namespace } from 'vuex-class'
import { Company } from '@/models/Company'
import FileTag from '@/enums/FileTag'
import FileDownloadLink from '@/components/FileDownloadLink.vue'

const Auth = namespace('auth')

@Component({
	components: { FileDownloadLink }
})
export default class ExternalInvoiceDownloadDialog extends Vue {
	@Auth.Getter('currentCompany')
	currentCompany!: Company

	@Prop({ required: true })
	invoice!: Invoice

	@Prop({ required: false, default: false })
	open!: boolean

	isLoading: boolean = false
	initialized: boolean = false
	initializing: boolean = false

	invoiceDocuments: Array<Document> = []
	transportDocuments: Array<Document> = []

	get transportInvoices(): Array<Document> {
		return this.transportDocuments.filter((d) => d.tag === FileTag.INVOICE)
	}

	get invoicesBySubContractor(): Array<Document> {
		return this.transportInvoices.filter(
			(d) => d.getUploader()?.getCompany()?.getApiId() !== this.currentCompany.getApiId()
		)
	}

	get documentsToDisplay(): Array<Document> {
		if (this.invoiceDocuments.length) return this.invoiceDocuments
		if (this.invoicesBySubContractor.length) return this.invoicesBySubContractor
		return this.transportDocuments
	}

	async created() {
		this.initializing = true

		try {
			const documentsQuery = this.invoice.documents().get()
			if (this.invoice?.getPdf()) {
				this.invoiceDocuments = [this.invoice?.getPdf()]
				this.invoiceDocuments = (await documentsQuery).getData() as Array<Document>
			} else {
				const transportIds = (this.invoice?.getTransports() ?? []).map((t) => t.getApiId())
				let query = Document.query().with('transport')
				transportIds.forEach((id) => (query = query.option('filter[transports][]', id as string)))
				this.transportDocuments = ((await query.get()) as PluralResponse).getData() as Array<Document>
			}

			this.initializing = false
			this.initialized = true
		} catch (e: any) {
			await this.close()
		}
	}

	async close() {
		this.$emit('closed')
		await this.$nextTick()
		this.initializing = false
		this.initialized = false
	}

	ofDifferentCompany(document: Document): boolean {
		return this.currentCompany.getApiId() !== document.getUploader()?.getCompany()?.getApiId()
	}
}
